<template>
  <v-layout
    column
    justify-start
    fill-height
    class="nx-notification-drawer"
  >
    <nx-staff-notification-drawer-header
      :unread-notifications="unreadNotifications.length"
      :notifications="notifications.length"
      @deleteAll="deleteNotifications"
    />
    <v-btn
      v-if="debugMode"
      @click="createFakeNotification"
    >
      CREATE FAKE NOTIFICATION
    </v-btn>
    <v-slide-x-transition
      group
      origin="top 0"
      hide-on-leave
    >
      <nx-notification
        v-for="notification in notifications"
        :key="notification.id"
        dark
        class="mb-2"
        :title="notification.title"
        :title-variables="notification.titleVariables"
        :chip="notification.tag"
        :chip-color="notification.tagColor"
        :image="notification.imageSrc"
        :url="notification.url"
        :datetime="notification.creationDate"
        :read="!!notification.readDate"
        :pinned="!!notification.pinnedDate"
        @input="handleInput(notification)"
        @delete="deleteNotification(notification)"
        @unread="unreadNotification(notification)"
        @pin="pinNotification(notification)"
        @unpin="unpinNotification(notification)"
      />
    </v-slide-x-transition>
  </v-layout>
</template>

<script>
import NxStaffNotificationDrawerHeader from '@/modules/staff-notification/components/StaffNotificationDrawerHeader.vue';
import NxNotification from '@/components/notification/Notification.vue';
import ManagesStaffNotifications from '@/modules/staff-notification/mixins/manages-staff-notifications';

export default {
  name: 'NxStaffNotificationDrawer',
  components: { NxNotification, NxStaffNotificationDrawerHeader },
  mixins: [ManagesStaffNotifications],
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    debugMode() {
      return this.$route.hash === '#debug';
    },
  },
  watch: {
    active(isActive) {
      if (isActive) {
        this.readAllNotifications();
        return;
      }

      if (this.notifications.length > 0) {
        // Refresh notifications state on close (cleanup reads etc...)
        this.loadNotifications();
      }
    },
  },
};
</script>

<style lang="stylus">
@import "../../../assets/stylus/variables.styl"

.nx-notification-drawer {
  background-color: $nx-primary--darken-3;
  height: 100%;
  padding-top: 48px;
  color: white;
  display: flex;
}
</style>
